import React from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";
import whyus from "../assets/whyyus.jpg";
import play from "../assets/play.png";
import apple from "../assets/app.png";
import cios from "../assets/cios.png";
import { Link } from "react-router-dom";
import WALLETVEN from "../assets/WALLETVEN.png"
import image from "../assets/omgnew.jpg"

const WhyUs = () => {
  return (
    <div className="Whyus mt-10 py-5 fs-60 column-resp">
      <div
        className="d-flex justify-content-between canvas canvas_col"
        style={{ position: "relative" }}
      >
        <img
          src={whyus}
          alt="latinotransfer img"
          className="w-50 me-5 rounded"
          style={{
            objectFit: "cover",
            height: "100vh",
          }}
        />
        <div className="why_content w-50">
          <h1 className="fw-bold">Tus Envíos 100% Garantizados</h1>
          <p className="font2 mt-2 fs-6 text-muted">
            Transferven te ofrece un servicio de envío de Dinero y Criptomonedas seguro, innovador, eficiente y con mayores beneficios. Ofrecemos soluciones simples para el cliente moderno. Seas particular o mayorista, todo lo que necesitas en un solo lugar, con tu Cuenta Transferven
          </p>

          <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">8 años a tu Servicio</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              Transferven es gestionado por un equipo de profesionales con gran trayectoria en el sector de las remesas hacia Venezuela y otros países de Latinoamérica. Nuestro servicio está disponible para todos los países de la Unión Europea.
            </p>
          </div>
          <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">Tu Envío Garantizado</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              Como Empresa Regulada, cumplimos con los más estrictos Protocolos de Seguridad, para garantizar una experiencia 100% Segura a todos los usuarios.
            </p>
          </div>
          <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">Atención Personalizada</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              En Transferven cuentas con una Atención directa y a tiempo real a través del Chat Online, para cualquier consulta o duda que necesites aclarar.
            </p>{" "}
          </div>
          <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">Proceso Simple</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              Desde la comodidad de tu hogar y a través de tu móvil. Gestiona tus Envíos de manera rápida y sencilla.
            </p>{" "}
          </div>
          <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">Atendemos a Empresas y Mayoristas</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              Te ofrecemos la solución para el pago de facturas en el extranjero tales como: Pago de Transporte de carga, Nóminas o Personal y cualquier otro servicio que tenga que ser abonado en Venezuela o desde Venezuela a Europa.
            </p>{" "}
          </div>

          <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">Trabaja con Nosotros</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              Los propietarios de negocios pueden ofrecer el servicio de Envío de Dinero a través de nuestra firma o de su marca propia. Aprovecha la oportunidad para aumentar tus ingresos con un negocio paralelo libre de riesgos.
            </p>{" "}
            <Link to={"/contact"} className="px-4 py-2 fs-6 rounded mt-3 continue" style={{ width: "fit-content" }}>Contáctanos</Link>
          </div>


          {/* <div className="mt-3">
            <div className="d-flex align-items-center mt-4">
              <BsFillCheckCircleFill color="#fc364e" size={27} />
              <p className="ms-2 fs-5 fw-bold">Comprar y Enviar Criptomonedas</p>
            </div>
            <p className="mt-1 text-muted fs-6 font2">
              {" "}
              Envía a Venezuela en Criptomonedas, directamente hacia la wallet que nos indiques. Con nuestro servicio Walletven, podrás comprar USDT y enviarlos a cualquier parte del mundo.
            </p>{" "}

          </div> */}

        </div>

      </div>

      <div className={`d-flex align-items-center mt-10 canvas 
     rounded p-3 px-0 pb-0 justify-content-between gap-3 ${window.matchMedia("(max-width: 850px)").matches && "flex-column"}`}>
        <div className="how_works2 w-50">
          <Link to="/walletven" className="d-block" style={{ width: "fit-content" }}>
            <img src={WALLETVEN} alt="Walletven" height={window.matchMedia("(max-width: 500px)").matches ? 35 : 45} />
          </Link>
          <h2 className="fs-1 fw-bold mt-3">
            Compra y envía
            Criptomonedas.<br />
            Simple y Seguro.
          </h2>

          <div className="mt-3">
            <p>
             Envía a Venezuela en Criptomonedas, directamente hacia la wallet que nos indiques. Con nuestro servicio Walletven, podrás comprar USDT y enviarlos a cualquier parte del mundo.También puedes adquirir otras Criptomonedas populares consultando con tu Agente Transferven.
            </p>
            <div className="d-flex mt-3">
              <Link to={"https://play.google.com/store/apps/details?id=com.transferven.app"} target="_blank">
                <img src={play} width={150} className="me-3" />
              </Link>
            </div>
          </div>
        </div>
        <img src={image} className="w-50 rounded-2 mt-md-0 mt-2" />
      </div>
    </div>
  );
};

export default WhyUs;
